import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'brand-bulma', 'IconBrandBulma', [["path",{"d":"M5 16l1 -9l5 -5l6.5 6l-3.5 4l5 5l-8 5z","key":"svg-0"}]]);